<template>
  <a-list itemLayout="horizontal">
    <a-list-item>
      <a-list-item-meta>
        <template v-slot:title>
          <a-upload name="file"
                    :multiple="true"
                    :headers="headers"
                    :action="uploadUrl"
                    :before-upload="beforeUpload"
                    @change="handleChange">
            <img v-if="imageUrl"
                 :src="imageUrl"
                 alt="avatar"
                 width="500" />
            <div v-else>
              <a-icon :type="loading ? 'loading' : 'plus'" />
              <div class="ant-upload-text">
                上传首页背景图片
              </div>
            </div>
          </a-upload>
        </template>
        <template v-slot:description>
          <a-button type="primary" @click="useDefaultImage">
            使用默认背景图
          </a-button>
        </template>
      </a-list-item-meta>
    </a-list-item>
  </a-list>
</template>
<script>
import { ACCESS_TOKEN } from '@/store/mutation-types'
import storage from 'store'

export default {
  data () {
    return {
      loading: false,
      imageUrl: '',
      uploadUrl: `${process.env.VUE_APP_API_BASE_URL}manager/tenants/home_image`, // 上传文件URL
      headers: {
        Authorization: storage.get(ACCESS_TOKEN)
      },
    }
  },
  created () {
    this.getTenantHomeImage()
  },
  methods: {
    getTenantHomeImage () {
      this.$http
        .get('manager/tenants/home_image')
        .then(({ data }) => {
          if (data) {
            this.imageUrl = data.configValue
          } else {
            this.$message.warning('未上传首页背景图')
          }
        })
        .catch(() => { })
    },
    handleChange (info) {
      const status = info.file.status
      if (status !== 'uploading') {
        console.log(info.file, info.fileList)
      }
      if (status === 'done') {
        if (info.file.response.code === 0) {
          console.log(info.file.response.data)
          this.$message.success(`${info.file.name} 文件上传成功.`)
          this.getTenantHomeImage()
        } else {
          this.$message.error(`${info.file.name} ${info.file.response.message}.`)
        }
      } else if (status === 'error') {
        this.$message.error(`${info.file.name} 文件上传失败.`)
      }
    },
    beforeUpload (file) {
      const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png'
      if (!isJpgOrPng) {
        this.$message.error('只能是jpeg或png格式')
      }
      const isLt2M = file.size / 1024 / 1024 < 5
      if (!isLt2M) {
        this.$message.error('图片不能大于 5MB!')
      }
      return isJpgOrPng && isLt2M
    },
    useDefaultImage () { 
      this.$http
        .get('manager/tenants/home_image/default')
        .then(() => {
          this.$message.success('已设置为默认背景图')
          this.getTenantHomeImage()
        })
        .catch(() => {
          this.$message.error('设置默认背景图失败')
        })
    }
  }
}
</script>
<style>
.avatar-uploader > .ant-upload {
  width: 128px;
  height: 128px;
}
.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}
</style>
